import { FinancialDocumentPdfTemplateType, FinancialDocumentType } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { IconName, ActionToolbarButton } from '@optimus-web/core';
import { useOpenSendEmailDialog } from '../../../../../../../../legacy/React/Components/HeadingAction/Action/SendFinancialDocumentToEmailAction';

interface SendReminderButtonProps {
    accountId: string;
    invoiceId: string;
    isSendReminderButtonDisabled: boolean;
}

export const SendReminderButtonLegacy = ({
    accountId,
    invoiceId,
    isSendReminderButtonDisabled,
}: SendReminderButtonProps) => {
    const toggleReminder = useOpenSendEmailDialog({
        ownerId: accountId,
        financialDocumentId: invoiceId,
        companyId: '',
        documentType: FinancialDocumentType.Bill,
        showPrintReason: false,
        type: 'SendReminder',
        allowedTemplateTypes: [
            FinancialDocumentPdfTemplateType.Detailed,
            FinancialDocumentPdfTemplateType.Consumption,
            FinancialDocumentPdfTemplateType.OrderItem,
            FinancialDocumentPdfTemplateType.Reservation,
        ],
    });

    return (
        <ActionToolbarButton
            icon={IconName.SendMessage}
            onClick={toggleReminder}
            disabled={isSendReminderButtonDisabled}
            actionToolbarEnabled
        >
            {lt('SendReminder')}
        </ActionToolbarButton>
    );
};
